module.exports = __webpack_public_path__ + "img/CARD_EXPIRED.png";